import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserServiceBase } from '@src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { GoogleResult } from '@src/app/ecom-items/ecom-item-cart-checkout/google-result.model';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';
import { WindowRef } from '@src/app/ecom-support-center/zoho-salesiq/WindowRef';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { SessionStorageService } from 'ngx-webstorage';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
declare var chatWindowLoad : Function;

@Component({
  selector: 'app-ecom-profile',
  templateUrl: './ecom-profile.component.html',
  styleUrls: ['./ecom-profile.component.scss'],
  providers: [WindowRef]
})
export class EcomProfileComponent implements OnInit {
  // component class properties
  public userForm: FormGroup;
  public addressForm: FormGroup;
  errorMessage: any;
  userAddresses = [];
  options = {
    types: [],
    componentRestrictions: { country: 'my' }
  };
  @ViewChild("placesRef", { static: true }) placesRef: GooglePlaceDirective;
  @ViewChild('useraddressPopup', { static: true }) useraddressPopup: ElementRef;
  //geoCoder: google.maps.Geocoder;
  modalRef: BsModalRef;
  config = {
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true,
  };
  saveclicked = false;
  userServiceBase: UserServiceBase;
  currentOrderCount = 0;
  pastOrderCount = 0;
  upcomingReservationCount = 0;
  googlePlaceSelected = '';
  searchTerm: string;
  googlePlacesResults: GoogleResult[] = [];
  googlePlace: any;
  overlayDisplay = false;
  window: any;
  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,private winRef: WindowRef,public formBuilder: FormBuilder, public router: Router, public ecomservice: EComService, private modalService: BsModalService, public mapsAPILoader: MapsAPILoader,
    public webstorage: EComWebStorage, private sessionSt: SessionStorageService, public _sanitizer: DomSanitizer, private cookie: EcomCookies, public ngZone: NgZone) {
    this.userServiceBase = new UserServiceBase();
    this.window = winRef.nativeWindow;
  }

  onLocationChange(data) {
    // if (data) {
    //   this.addressForm.controls.ooca_place_id.setValue(data.place_id);
    //   let request = {
    //     "placeId": data.place_id
    //   }
    //   const map = new google.maps.Map(document.getElementById("map"), {
    //     center: {
    //       lat: 2.198470,
    //       lng: 102.239372
    //     },
    //     zoom: 14
    //   });
    //   const mapPlaceService = new google.maps.places.PlacesService(map);
    //   mapPlaceService.getDetails(request, (place, status) => {
    //     this.setPlaceDetails(place);
    //   });
    // }
  }


  setPlaceDetails(place) {
    //verify result
    if (place.geometry === undefined || place.geometry === null) {
      return;
    }
    const postalcode = place.address_components.find(obj => {
      return obj.types[0] === 'postal_code'
    });
    if (postalcode !== undefined) {
      this.addressForm.controls.ooca_postal_code.setValue(postalcode.long_name);
    }
    this.addressForm.controls.ooca_latlang.setValue(place.geometry.location.lat() + ',' + place.geometry.location.lng());
    this.addressForm.controls.ooca_address_url.setValue(place.url);
    const city = place.address_components.find(obj => {
      return obj.types[0] === 'locality'
    });
    if (city !== undefined) {
      this.addressForm.controls.ooca_city.setValue(city.long_name);
    }
    let address = place.formatted_address;
    if (!address.includes(place.name)) {
      address = place.name + ', ' + place.formatted_address;
    }
    this.addressForm.controls.ooca_address.setValue(address);
    const trackingInput = {
      gat_ipaddress: this.webstorage.localSt_ip,
      gat_type: 'PLACE CHANGE API'
    };
    this.ecomservice.googleApiTrack(trackingInput);
  }

  getData() {
    // this.placePredictionService.currentData.subscribe((response: GoogleResult[]) => {
    //   if (response) {
    //     this.googlePlacesResults = response;
    //   } else {
    //     this.googlePlacesResults = [];
    //     this.addressForm.controls.ooca_place_id.reset();
    //   }
    // });
  }

  placesKeyUp(event) {
    this.addressForm.controls.ooca_place_id.setValue(null);
    let value = event.target.value;
    if (value && value.length >= 3) {
      this.onSearch(value);
    }
  }

  customSearchFn(term: string, item: any) {
    return true;
  }

  onSearch(term: string) {
    this.searchTerm = term;

    if (this.searchTerm === '') {
      return;
    }

    //this.placePredictionService.getPlacePredictions(term);
  }

  // component initialize and load the required data
  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'profile'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    chatWindowLoad('none');
    this.getData();
    if (!this.webstorage.sessionSt_is_session_valid) {
      this.router.navigate(['home']);
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.userForm = this.formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: [''],
      countryCode: [],
      mobile: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required])],
      image: ['./assets/images/profile.png'],
      address: [],
      referralsCount: [],
      olarsCount: [],
      vouchersCount: [],
      currentOrdersCount: [],
      pastOrdersCount: [],
      upcomingReservationCount: []
    });
    this.addressForm = this.formBuilder.group({
      ooca_guid: [],
      ooca_ooc_guid: [],
      ooca_address_label: ['', Validators.compose([Validators.required])],
      ooca_address: ['', Validators.compose([Validators.required])],
      ooca_city: ['', Validators.compose([Validators.required])],
      ooca_postal_code: [''],
      ooca_latlang: [],
      ooca_address_url: [],
      ooca_address_landmark: ['', Validators.compose([Validators.required])],
      ooca_is_default: [],
      ooca_place_id: ['', Validators.compose([Validators.required])],
    });
    //this.googleMapLocationAutocomplete();
    if (this.cookie.cookie_authtoken === '') {
      this.router.navigate(['login']);
    } else {
      this.LoadPage();
    }



    this.sessionSt.observe('sessionst_currentordercount')
      .subscribe((value) => this.setCurrentOrderCount(value));

    this.sessionSt.observe('sessionst_pastordercount')
      .subscribe((value) => this.setPastOrderCount(value));

    this.sessionSt.observe('sessionst_upcomingreservationcount')
      .subscribe((value) => this.setUpcomingReservationOrderCount(value));
  }

  setCurrentOrderCount(value) {
    this.userForm.controls.currentOrdersCount.setValue(value);
    this.currentOrderCount = value;
  }

  setPastOrderCount(value) {
    this.userForm.controls.pastOrdersCount.setValue(value);
    this.pastOrderCount = value;
  }

  setUpcomingReservationOrderCount(value) {
    this.userForm.controls.upcomingReservationCount.setValue(value);
    this.upcomingReservationCount = value;
  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.getUser();
        }
      });
    } else {
      this.getUser();
    }
  }

  // Method to get the user details by it's id
  getUser() {
    const userId = this.webstorage.localSt_user_id;
    this.ecomservice.httpGet(EcomNetworkUtils.GET_PROFILE + '?Id=' + userId, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          this.userForm.controls.firstname.setValue(response.listValue.ooc_customer_firstname);
          this.userForm.controls.lastname.setValue(response.listValue.ooc_customer_lastname);
          this.userForm.controls.mobile.setValue(response.listValue.ooc_customer_mobile);
          this.userForm.controls.countryCode.setValue(response.listValue.ooc_country_dial_code);
          this.userForm.controls.email.setValue(response.listValue.ooc_customer_email);
          if (response.listValue.ooc_customer_imagename.length > 0) {
            this.userForm.controls.image.setValue(response.listValue.ooc_customer_imagename);
          }
          this.userForm.controls.referralsCount.setValue(response.listValue.ReferralsCount);
          this.userForm.controls.olarsCount.setValue(response.listValue.OlarsCount);
          this.userForm.controls.vouchersCount.setValue(response.listValue.VouchersCount);
          this.userForm.controls.currentOrdersCount.setValue(response.listValue.CurrentOrderCount);
          this.userForm.controls.pastOrdersCount.setValue(response.listValue.PastOrderCount);
          this.userForm.controls.upcomingReservationCount.setValue(response.listValue.UpComingReservationCount);

          this.setUserAddressList(response.listValue.ListCustomerAddress);

          //update user details to local storage
          // update the user service request
          this.userServiceBase = this.webstorage.localSt_user_service_request ? this.webstorage.localSt_user_service_request : new UserServiceBase();
          this.userServiceBase.userDialCode = response.listValue.ooc_country_dial_code;
          this.userServiceBase.userMobile = response.listValue.ooc_customer_mobile;
          this.webstorage.localSt_user_service_request = this.userServiceBase;

        } else {
          this.errorMessage = response.msg;
          //this.router.navigate(['login']);
          this.ecomservice.commonLoading.show = false;
          this.setUserAddressList([]);
        }
      }
    });
  }

  setUserAddressList(listValue) {
    this.userAddresses = [];
    this.userAddresses.push({
      ooca_address: "",
      ooca_address_label: "click to save your delivery address",
      ooca_address_landmark: "",
      ooca_address_url: "",
      ooca_city: "",
      ooca_created_at: "",
      ooca_guid: "",
      ooca_is_default: false,
      ooca_is_deleted: false,
      ooca_latlang: "",
      ooca_ooc_guid: "",
      ooca_postal_code: "",
      ooca_updated_at: ""
    });
    // user address list
    if (listValue && listValue.length > 0) {
      listValue.forEach(element => {
        this.userAddresses.push(element)
      });
      // get the default address
      let defaultIndex = -1;
      let defaultAddress = this.userAddresses.find((obj, index) => {
        defaultIndex = index;
        return obj.ooca_is_default === true;
      });
      if (defaultAddress !== undefined) {
        this.userForm.controls.address.setValue(defaultAddress.ooca_guid);
      } else {
        // set 0th address as default address
        this.userForm.controls.address.setValue(this.userAddresses[1].ooca_guid);
      }
    } else {
      this.userForm.controls.address.setValue(this.userAddresses[0].ooca_guid);
    }
  }

  // Method to handle the account view click event
  onViewAccountClick() {
    this.webstorage.sessionSt_frompage = 'profile';
    this.webstorage.sessionSt_topage = 'profile-edit';
    this.router.navigate([this.webstorage.sessionSt_topage]);
  }

  // Method to handle the profile link click event
  onProfileDetailClick(type) {
    this.webstorage.sessionSt_frompage = 'profile';
    switch (type) {
      case 'OLARS':
        this.webstorage.sessionSt_topage = 'olar-points';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'VOUCHERS':
        this.webstorage.sessionSt_topage = 'user-vouchers';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'REFERRALS':
        this.webstorage.sessionSt_topage = 'user-referrals';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'UPCOMING_ORDERS':
        this.webstorage.sessionSt_topage = 'user-reservation';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'ORDERS':
        this.webstorage.sessionSt_topage = 'orders';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'UPCOMING_RESERVATIONS':
        this.webstorage.sessionSt_topage = 'user-reservation';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'PAYMENT_METHODS':
        this.webstorage.sessionSt_topage = 'payment-methods';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'CONTACT_SUPPORT':
        this.overlayOpen();
        break;
      case 'LANGUAGE':
        // this.router.navigate(['orders']);
        break;
      case 'CHANGE_PASSWORD':
        this.webstorage.sessionSt_topage = 'changepassword';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
      case 'LOG_OUT':
        // clear the token
        this.cookie.delete_cookie('authtoken');
        this.webstorage.sessionSt_topage = 'login';
        this.router.navigate([this.webstorage.sessionSt_topage]);
        break;
    }
  }

  onAddressChange(event) {

  }

  onBackClick() {
    if (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true) {
      if (this.webstorage.sessionSt_frompage === 'cart') {
        this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
      } else if (this.webstorage.sessionSt_frompage === 'checkout') {
        this.router.navigate(['checkout', this.webstorage.sessionSt_company_clicked]);
      } else {
        this.router.navigate(['items', this.webstorage.sessionSt_company_clicked]);
      }
    } else if (this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) {
      if (this.webstorage.sessionSt_frompage === 'cart') {
        this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked])
      } else if (this.webstorage.sessionSt_frompage === 'checkout') {
        this.router.navigate(['checkout', this.webstorage.sessionSt_company_clicked]);
      } else {
        this.router.navigate(['items', this.webstorage.sessionSt_company_clicked]);
      }
    } else {
      if (this.webstorage.sessionSt_frompage === 'login') {
        this.router.navigate(['stores']);
      } else if (this.webstorage.sessionSt_frompage === 'cart') {
        this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked])
      } else if (this.webstorage.sessionSt_frompage === 'checkout') {
        this.router.navigate(['checkout', this.webstorage.sessionSt_company_clicked]);
      } else {
        this.router.navigate(['stores']);
      }
    }
    this.webstorage.sessionSt_frompage = 'login';
  }

  // Method to handle the redirection
  successRedirect() {
    if (this.webstorage.sessionSt_frompage === null || this.webstorage.sessionSt_frompage === 'home') {
      this.router.navigate(['home']);
    } else {
      const fromPage = this.webstorage.sessionSt_frompage;
      switch (fromPage) {
        case 'login':
          this.router.navigate(['profile']);
          break;
        // case 'store':
        //   this.router.navigate(['store']);
        //   break;
        case 'cart':
          this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked])
          break;
        case 'checkout':
          this.router.navigate(['checkout', this.webstorage.sessionSt_company_clicked]);
          break;
        case 'orders':
          this.router.navigate(['orders']);
          break;
        case 'profile':
          this.router.navigate(['profile']);
          break;
        case 'payment':
          this.router.navigate(['payment-methods']);
          break;
        default:
          this.router.navigate(['home']);
          break;
      }
    }
    this.webstorage.sessionSt_frompage = 'profile';
  }

  onAddAddressClick(item) {
    this.addressForm.reset();
    if (item.ooca_guid) {
      this.addressForm.controls.ooca_guid.setValue(item.ooca_guid);
      this.addressForm.controls.ooca_ooc_guid.setValue(item.ooca_ooc_guid);
      this.addressForm.controls.ooca_address_label.setValue(item.ooca_address_label);
      this.addressForm.controls.ooca_address.setValue(item.ooca_address);
      this.addressForm.controls.ooca_city.setValue(item.ooca_city);
      this.addressForm.controls.ooca_postal_code.setValue(item.ooca_postal_code);
      this.addressForm.controls.ooca_latlang.setValue(item.ooca_latlang);
      this.addressForm.controls.ooca_address_url.setValue(item.ooca_address_url);
      this.addressForm.controls.ooca_address_landmark.setValue(item.ooca_address_landmark);
      this.addressForm.controls.ooca_is_default.setValue(item.ooca_is_default);
      let googlePlaceSelected = {
        description: item.ooca_address,
        id: '',
        matched_substrings: [],
        place_id: item.ooca_place_id,
        reference: '',
        structured_formatting: null,
        terms: [],
        types: []
      };
      let result = this.googlePlacesResults.find(obj => {
        return obj.place_id === item.ooca_place_id;
      });
      if (result === undefined) {
        this.googlePlacesResults.push(googlePlaceSelected);
      }
      this.addressForm.controls.ooca_place_id.setValue(item.ooca_place_id);
    }
    this.modalRef = this.modalService.show(this.useraddressPopup, this.config);
  }

  onCloseClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  // method to save the address
  onSaveAddressClick() {
    if (this.addressForm.invalid) {
      Object.keys(this.addressForm.controls).forEach(key => {
        this.addressForm.get(key).markAsDirty();
      });
      return;
    } else {
      this.saveclicked = true;
      const input = this.addressForm.value;
      input.ooca_ooc_guid = this.webstorage.localSt_user_id;
      
      this.ecomservice.httpPost(EcomNetworkUtils.POST_SAVE_USER_ADDRESS, input, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          this.saveclicked = false;
          if (response.isSuccess) {
            // if new address add to list else update the list
            let addressindex = -1;
            let address = this.userAddresses.find((obj, index) => {
              addressindex = index;
              return obj.ooca_guid === input.ooca_guid;
            });
            if (address) {
              this.userAddresses[addressindex].ooca_address_label = input.ooca_address_label;
              this.userAddresses[addressindex].ooca_address = input.ooca_address;
              this.userAddresses[addressindex].ooca_city = input.ooca_city;
              this.userAddresses[addressindex].ooca_postal_code = input.ooca_postal_code;
              this.userAddresses[addressindex].ooca_address_landmark = input.ooca_address_landmark;
              this.userAddresses[addressindex].ooca_is_default = input.ooca_is_default;
            } else {
              this.userAddresses.push(response.listValue);
            }
            this.setUserAddressList(response.listValues);
            this.modalRef.hide();
            //$('.modal').css({"display": "none"});
          } else {
            this.errorMessage = response.msg;
          }
        }
      });
    }
  }


  handleAddressChange(address: Address) {
    this.addressForm.controls['ooca_city'].reset();
    this.addressForm.controls['ooca_postal_code'].reset();
    this.addressForm.controls.ooca_address.setValue(address.name + ',' + address.formatted_address);
    const usercity = address.address_components.find(obj => {
      return obj.types[0] === 'locality'
    });
    if (usercity !== undefined) {
      this.addressForm.controls.ooca_city.setValue(usercity.long_name);
    }
    const postalcode = address.address_components.find(obj => {
      return obj.types[0] === 'postal_code'
    });
    if (postalcode !== undefined) {
      this.addressForm.controls.ooca_postal_code.setValue(postalcode.long_name);
    }
    this.addressForm.controls.ooca_latlang.setValue(address.geometry.location.lat() + ',' + address.geometry.location.lng());
    this.addressForm.controls.ooca_address_url.setValue(address.url);
    const trackingInput = {
      gat_ipaddress: this.webstorage.localSt_ip,
      gat_type: 'PLACE CHANGE API'
    };
    this.ecomservice.googleApiTrack(trackingInput);
  }

  overlayOpen() {
    this.overlayDisplay = true;
  }

  closeOverlay() {
    this.overlayDisplay = false;
  }

  contactUsEventEmitter(event){
    this.overlayDisplay = false;
  }

  onChatStartClick() {
    this.overlayDisplay = false;
    this.window && this.window.$zoho.salesiq.floatwindow.visible('show');
  }

  listYourRestaurantClick() {
    this.overlayDisplay = false;
    window.open(this.ecomservice.GetOlarConfigValue('merchantmate'), "_blank");
  }

  // Method to handle the click event
  onCallClick(phonenumber) {
    document.location.href = 'tel:' + phonenumber;
  }

}
